import PropTypes from 'prop-types';
import EnumerableShape from './EnumerableShape';

export default PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]);

export const modifierShapeGenerator = EnumerableShape;
